import React, {useEffect, useState} from 'react';
import style from'./instructions.module.css'
import API from "../../API"
import edit from '../../../img/edit2.png'
import {ReturnTextAndImg} from "../../test/CheckImg";
import AddFile from "../../creators/questionCreator/components/AddFile";
import {ru} from "../../data/ru";
import {by} from "../../data/by";

const Instructions = () => {
    let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdOne : by.RoleIdOne;

    const [instructions,setInstructions] = useState([])
    const [roleNumber,setRoleNumber] = useState(0)
    const [openEdit,setIsOpenEdit] =useState(false)
    const [value,setValue] = useState('')

    const api =new API()
    const getInstructions =()=>{
        api.getInstructions(true).then(data=>{
            setInstructions(data)
        })
    }
    useEffect(()=>{
        getInstructions()
    },[])

    const clickRoleHandler=(index)=>{
        setRoleNumber(index)
        setIsOpenEdit(false)
    }

    const editOpenHandler =()=>{
        setIsOpenEdit(prev=>!prev)
        setValue(instructions[roleNumber].text)
    }
    const changeValueHandler =(e)=>{
        setValue(e.target.value)
    }
    const send =()=>{
        const role = instructions[roleNumber].slug;
        const text = {text:value};
        api.editInstructions(role,text).then(data=>{getInstructions()})
    }
    const roles = instructions.map((item,i)=><div key={item.slug} onClick={()=>clickRoleHandler(i)} className={style.roleItem}>{item.name}</div>)
    const editInput =
        <>
            <div className={style.textAndFileContainer}>
                <textarea value={value} onChange={e=>changeValueHandler(e)} className={style.text}/>
                <AddFile/>
            </div>
            <button onClick={()=>send()} className={style.buttonSend}>{language.send}</button>
        </>
    return (
        <div className={style.container}>
            <div className={style.roleContainer}>
                {roles}
                <button onClick={()=>editOpenHandler()} className={style.editButton}>
                    <img src={edit} alt={'edit'}/>
                </button>
            </div>
            <div className={style.textContainer}>
                {instructions.length!==0 && <h1 className={style.roleTitle}>{instructions[roleNumber].name}</h1>}
                {!openEdit && instructions.length!==0 && ReturnTextAndImg(instructions[roleNumber].text)}
                {openEdit && editInput}
            </div>
        </div>
    );
};

export default Instructions;